import React, { createContext, useContext, useState, useEffect } from 'react';
import { initializeAPI } from '../api/apiService';

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const response = await fetch('/config.json');
        if (!response.ok) {
          throw new Error('Failed to load configuration');
        }
        const data = await response.json();
        setConfig(data);
        // Initialize API service with runtime config
        initializeAPI(data);
      } catch (err) {
        console.error('Error loading config:', err);
        setError(err.message);
        // Fallback to environment variables if config.json fails
        const fallbackConfig = {
          // API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8003',
          API_BASE_URL: "",
          APP_NAME: 'PayrollGen',
          VERSION: '1.0.0'
        };
        setConfig(fallbackConfig);
        // Initialize API service with fallback config
        initializeAPI(fallbackConfig);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        <div>Loading configuration...</div>
      </div>
    );
  }

  return (
    <ConfigContext.Provider value={{ config, error }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

export default ConfigContext;
